var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderSideArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42769 8.00477e-07H0.572305C0.459167 -0.000176325 0.348517 0.0290454 0.254382 0.0839616C0.160247 0.138878 0.086867 0.217015 0.0435437 0.308468C0.000220468 0.399921 -0.0110944 0.500571 0.0110334 0.597658C0.0331612 0.694745 0.0877351 0.783896 0.167837 0.85381L3.59553 3.85314C3.6486 3.89969 3.71164 3.93663 3.78105 3.96183C3.85045 3.98703 3.92486 4 4 4C4.07514 4 4.14955 3.98703 4.21895 3.96183C4.28836 3.93663 4.3514 3.89969 4.40447 3.85314L7.83216 0.85381C7.91226 0.783896 7.96684 0.694745 7.98897 0.597658C8.01109 0.500571 7.99978 0.399921 7.95646 0.308468C7.91313 0.217015 7.83975 0.138878 7.74562 0.0839616C7.65148 0.0290454 7.54083 -0.000176325 7.42769 8.00477e-07Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSideArrow);
export default __webpack_public_path__ + "static/media/calender_side_arrow.e2e6eeaf87385e6446be3b0654b762ed.svg";
export { ForwardRef as ReactComponent };